import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const organisationPlugin = createPlugin({
  id: 'organisation',
  routes: {
    root: rootRouteRef,
  },
});

export const OrganisationPage = organisationPlugin.provide(
  createRoutableExtension({
    name: 'OrganisationPage',
    component: () =>
      import('./components/OrgComponent').then(m => m.OrgComponent),
    mountPoint: rootRouteRef,
  }),
);
